import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  createBankingExport,
  filterPayments,
} from '../../redux/actions/payments';
import {
  ButtonGroup,
  IconButton,
  Notification,
  PaymentTable,
  RouteWrapper,
  HeadingSection,
  Section,
} from '../../components';

interface Props {
  isFetching: boolean;
  filtered: boolean;
  paymentCount: number;
  dispatch: Function;
}

interface State {
  update: number;
  errorMessage: string | boolean;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      update: 0,
      errorMessage: false,
    };
  }

  render() {
    return (
      <RouteWrapper
        title="Received Payments"
        requireAuth
        requirePermission="MANAGE_PAYMENTS"
      >
        <HeadingSection title="Received Payments" />
        <Section>
          <ButtonGroup>
            <IconButton
              key="filter-button"
              handleClick={() => {
                if (!this.props.isFetching) {
                  this.props.dispatch(filterPayments());
                }
              }}
              icon={this.props.filtered ? 'eye-slash' : 'eye'}
              className={`is-${this.props.filtered ? 'default' : 'primary'}`}
            >
              Archived
            </IconButton>
            <IconButton
              key="banking-export-button"
              icon="file"
              className={`is-default is-pulled-right ${(this.props
                .paymentCount === 0 ||
                !this.props.filtered) &&
                'is-static'}`}
              handleClick={async () => {
                if (
                  !this.props.isFetching &&
                  window.confirm(
                    'Are you sure you would like to generate a banking export?',
                  )
                ) {
                  this.setState({ errorMessage: false });
                  const response = await this.props.dispatch(
                    createBankingExport(),
                  );
                  if (!response.error) {
                    this.props.dispatch(
                      push(`/payments/banking-export/${response.data.id}`),
                    );
                  } else {
                    this.setState({ errorMessage: response.error });
                  }
                }
              }}
            >
              Generate Banking Export
            </IconButton>
            <IconButton
              key="pending-account"
              icon="file"
              className="is-default is-pulled-right"
              link="/payments/banking-export"
            >
              Banking Exports
            </IconButton>
            <IconButton
              key="pending-account"
              icon="university"
              className="is-default is-pulled-right"
              link="/payments/pending-account"
            >
              Pending Account Payments
            </IconButton>
            <IconButton
              key="pending-account"
              icon="credit-card"
              className="is-default is-pulled-right"
              link="/payments/pre-auth"
            >
              Pre-Auth Bookings
            </IconButton>
          </ButtonGroup>
          <div className="columns">
            <div className="column">
              <PaymentTable
                isArchived={!this.props.filtered}
                update={this.state.update}
              />
            </div>
          </div>
          {this.state.errorMessage && (
            <div className="columns">
              <div className="column">
                <Notification type="danger">
                  {this.state.errorMessage}
                </Notification>
              </div>
            </div>
          )}
        </Section>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ payments }) => ({
  isFetching: payments.isFetching,
  filtered: payments.filtered,
  paymentCount: payments.payments.length,
});

export default connect(mapStateToProps)(Route);
